<div class="modal-content">
  <div *ngIf="title" class="modal-header">
    <h4 class="modal-title d-inline-block align-middle">{{ title }}</h4>
    <i class="fas fa-times close pull-right align-middle mt" aria-label="Close" (click)="handleClick({ close: true })"></i>
  </div>
  <div class="modal-body text-center">
    <div *ngIf="!title" class="pb-4">
      <i class="fas fa-times close pull-right align-middle" aria-label="Close" (click)="handleClick({ close: true })"></i>
    </div>
    <jhi-bary-icon *ngIf="icon" [icon]="icon" [faDirective]="FAS" size="4x" [class]="class"></jhi-bary-icon>
    <p class="lead pt-4 px-3" [innerHTML]="message"></p>
  </div>
  <div class="modal-footer flex-column flex-md-row flex-nowrap justify-content-center">
    <jhi-bary-button
      *ngIf="buttons.submit"
      [block]="!buttons.second"
      color="primary"
      [label]="buttons.submit"
      (clickEvent)="handleClick({ submit: true })"
      class="mb-2 mb-md-0 mr-0 mr-md-2"
      data-id-cypress="modal-confirm"
    ></jhi-bary-button>
    <jhi-bary-button *ngIf="buttons.second" [outline]="true" [label]="buttons.second" (clickEvent)="handleClick({ second: true })"></jhi-bary-button>
  </div>
</div>
